module.exports = __webpack_public_path__ + "img/star03.74520303.png";